<!--用户名输入搜索,返回username -->
<template>
  <div>
    <el-autocomplete class="inline-input"
                     v-model="username"
                     :fetch-suggestions="querySearch"
                     placeholder=""
                     :trigger-on-focus="false"
                     @select="handleSelect"
                     :clearable="true"
                     @clear="() => {$emit('update:username', null)}"
    />
  </div>
</template>

<script>
import api from "@/api/projectApi";

export default {
  name: 'usernameSearch',
  props: {
    username: {
      required: true
    },
  },
  components: {},
  data() {
    return {
      // username: null
    }
  },

  watch: {

  },


  methods: {
    // 获取提示
    querySearch(queryStr, callback) {
      this.$http({
        url: api.sysUser.promptDataUrl + '/' + queryStr,
        method: 'get',
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.username, id: item.id})
        })
        callback(temp)
      })
    },

    // 提示选中
    handleSelect(data) {
      console.log('选中数据', data)
      this.$emit('update:username', data.value)
    },
  },
};
</script>

<style scoped lang="scss">

</style>
